import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-svg',
  templateUrl: './logo-svg.component.svg',
  styleUrls: ['./logo-svg.component.scss'],
  host: { '[class.color]': 'color == "primary"' }
})
export class LogoSvgComponent implements OnInit {
  @Input() color: 'primary' | 'white' = 'white';

  constructor() {}

  ngOnInit() {}
}
